import { render, staticRenderFns } from "./DirectorSelector.vue?vue&type=template&id=1ed83135&scoped=true&"
import script from "./DirectorSelector.vue?vue&type=script&lang=js&"
export * from "./DirectorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed83135",
  null
  
)

export default component.exports